module.exports = __webpack_public_path__ + "img/img-null.7840a18c.png";